<template>
    <div class="d-container vm--overlay" v-show="showModal">
    <div class="ddialog">
        <div class="vue-dialog-content"><div class="vue-dialog-content-title">{{modalTitle}}</div> <div>{{modalBody}}</div></div>
    <div class="vue-dialog-buttons"><button type="button" tabindex="0" class="vue-dialog-button" style="flex: 1 1 100%;" @click="close()">{{ $t("global.ok")}}</button></div>
    </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from 'vuex'

export default {
  name: 'GuiError',
  components: {
  },
  computed: {...mapState({
    showModal: state => state.chat.diagnostics.showModal,
    modalBody: state => state.chat.diagnostics.modalBody,
    modalTitle: state => state.chat.diagnostics.modalTitle,
  }),
 
  },
  methods:{
    close() {
    this.$store.dispatch('chat/setAttribute', { showModal: false });
    },
  }
}
</script>

<style scoped>
  .ddialog{
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    left: 0px;
    width: 356px;
    height: auto;
    top: 113px;
  }
  .d-container{
    position: fixed;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
  }
</style>